import { render, staticRenderFns } from "./MyCalculationsTable.vue?vue&type=template&id=38607126&"
import script from "./MyCalculationsTable.vue?vue&type=script&lang=js&"
export * from "./MyCalculationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports